import { useMutation } from '@tanstack/react-query';

import {
  addFolderItem,
  removeFolderItem,
  reorderFolderItems,
} from '../fetchers/folderItems';
import { folderKeys } from '../folder.keys';

import { useSyncFolder } from './useSyncFolder';

export const useAddFolderItem = () => {
  const sync = useSyncFolder();
  return useMutation({
    mutationKey: folderKeys.mutations(),
    scope: { id: 'folder-items' },
    mutationFn: ({
      id,
      quizsetId,
      confirmSourcePublication = false,
    }: {
      id: string;
      quizsetId: string;
      confirmSourcePublication?: boolean;
    }) => addFolderItem(id, quizsetId, confirmSourcePublication),
    onSuccess: folder => sync(folder),
  });
};

export const useRemoveFolderItem = () => {
  const sync = useSyncFolder();
  return useMutation({
    mutationKey: folderKeys.mutations(),
    scope: { id: 'folder-items' },
    mutationFn: ({ id, quizsetId }: { id: string; quizsetId: string }) =>
      removeFolderItem(id, quizsetId),
    onSuccess: folder => sync(folder),
  });
};

/**
 * 순서 변경.
 *
 * 추가·삭제와 같은 스코프를 쓴다 — 셋이 같은 목록을 건드리므로 react-query 가 직렬화하게 한다.
 * 응답의 `items` 는 미리보기 4개라 상세 캐시에 써넣지 않고 무효화만 한다.
 */
export const useReorderFolderItems = () => {
  const sync = useSyncFolder();
  return useMutation({
    mutationKey: folderKeys.mutations(),
    scope: { id: 'folder-items' },
    mutationFn: ({
      id,
      orderedQuizsetIds,
    }: {
      id: string;
      orderedQuizsetIds: string[];
    }) => reorderFolderItems(id, orderedQuizsetIds),
    onSuccess: folder => sync(folder),
  });
};
